import axiosClient from '@services/axiosClient';
import EndPoints from '@services/endpoints';
import { AxiosResponse } from 'axios';
import RomeDomain from '@enterprise/models/dto/rome-domain.response.dto';
import IPaginatedesponse from '@models/paginated-reponse';
import UpdateRomeDomainOrderDto from '@models/dto/update-rome-domain-order.dto';

export const getRomeDomainsPaged = async (
  query: string,
): Promise<AxiosResponse<IPaginatedesponse<RomeDomain>>> => {
  return await axiosClient.get(EndPoints.romeDomain.getRomeDomains(query));
};

export const reorderRomeDomains = async (
  payload: UpdateRomeDomainOrderDto[],
): Promise<AxiosResponse<IPaginatedesponse<RomeDomain>>> => {
  return await axiosClient.put(EndPoints.romeDomain.reOrder(), payload);
};

export const getAllRomeDomains = async (): Promise<
  AxiosResponse<RomeDomain[]>
> => {
  return await axiosClient.get(EndPoints.romeDomain.getAll());
};
